// =============================================================================
// Alarm sound — Web Audio API beep (2 nada cepat, total ~400ms).
// Pakai oscillator agar tidak perlu file mp3 (browser kadang block autoplay
// untuk <audio>; oscillator yang di-trigger sesudah user gesture aman).
//
// NOTE: browser block AudioContext sebelum ada user gesture (klik/keystroke).
// Component mount tidak cukup — pastikan suara dipicu oleh handler event,
// bukan oleh efek pasif. Login flow sudah pasti ada gesture, jadi aman.
// =============================================================================

let cachedCtx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (cachedCtx) return cachedCtx;
  const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  cachedCtx = new Ctor();
  return cachedCtx;
}

function beep(freq: number, durationMs: number, startOffset = 0) {
  const ctx = getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.value = 0.18;
  osc.connect(gain);
  gain.connect(ctx.destination);
  const start = ctx.currentTime + startOffset / 1000;
  osc.start(start);
  osc.stop(start + durationMs / 1000);
}

/**
 * playAlarmSound — dua nada cepat (880Hz lalu 660Hz) sebagai notifikasi.
 * No-op kalau Web Audio tidak tersedia.
 */
export function playAlarmSound() {
  try {
    beep(880, 180, 0);
    beep(660, 180, 200);
  } catch {
    // Swallow — jangan crash app cuma karena audio gagal.
  }
}
